import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ERROR_MSG_QUERY_KEY } from "../contant";
import { toast } from "react-toastify";

export default function NotFoundPage({errorMessage = "Page Not Found!"}) {
  const location = useLocation();
  const queryParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  useEffect(() => {
    const errorMessage = queryParams.get(ERROR_MSG_QUERY_KEY)?.trim();
    if (errorMessage) toast.error(errorMessage);
  }, [queryParams]);

  return (
    <div className="text-gray-900 text-center font-bold mt-24 text-2xl font-notoSans">
      {errorMessage}
    </div>
  );
}
